import { render, staticRenderFns } from "./ErrorNotFound.vue?vue&type=template&id=5b83362d&scoped=true&"
import script from "./ErrorNotFound.vue?vue&type=script&lang=js&"
export * from "./ErrorNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83362d",
  null
  
)

export default component.exports